export default {
  'employee.searchBar.button': 'Create New Employee',
  'employee.list.header.name': 'Employee Name',
  'employee.list.header.gender': 'Gender',
  'employee.list.header.registry': 'Registry',
  'employee.list.header.function': 'Function',
  'employee.list.header.contactType': 'Contact Type',
  'employee.list.header.role': 'Role',
  'employee.list.header.email': 'e-mail',
  'employee.list.header.phone': 'Phone Number',
  'employee.list.header.includedAt': 'Included At',
  'employee.list.header.actions': 'Actions',
  'employee.list.column.actions.button': 'View/Edit',
  'employee.filter.registry': 'Registry',
  'employee.filter.function': 'Function',
  'employee.create.notification.success': 'Success',
  'employee.create.notification.successDescription': 'Employee created.',
  'employee.update': 'Update Employee',
  'employee.update.notification.success': 'Success',
  'employee.update.notification.successDescription': 'Employee updated.',
  'employee.create.notification.successDescription': 'Employee created.',
  'employee.remove.modal.title': 'Remove Employee',
  'employee.remove.modal.content': 'Do you want to remove the employee',
  'employee.remove.modal.button.ok': 'Remove',
  'employee.remove.notification.success': 'Success',
  'employee.remove.notification.successDescription': 'Employee deleted.',
  'employee.personal.form.employeeName': 'Employee Name',
  'employee.personal.sexType': 'Sex',
  'employee.personal.genderType.man': 'MAN',
  'employee.personal.genderType.woman': 'WOMAN',
  'employee.personal.form.cpf': 'CPF',
  'employee.personal.form.rg': 'RG',
  'employee.personal.form.birth': 'Birth',
  'employee.personal.form.birthday': 'Birthday',
  'employee.personal.form.upUntil': 'Until',
  'employee.personal.form.phone1': 'Phone 1 (00) 00000-0000',
  'employee.personal.form.phone2': 'Phone 2 (00) 00000-0000',
  'employee.personal.form.email': 'E-mail',
  'employee.personal.form.companies': 'Companies',
  'employee.personal.form.gender': 'Gender',
  'employee.personal.form.cep': 'CEP',
  'employee.personal.form.uf': 'UF',
  'employee.personal.form.city': 'City',
  'employee.personal.form.district': 'District',
  'employee.personal.form.street': 'Street',
  'employee.personal.form.number': 'Number',
  'employee.personal.form.complement': 'Complement',
  'employee.personal.form.zone': 'Zone',
  'employee.personal.form.upload': 'Upload profile image',
  'employee.personal.form.observation': 'Observations',
  'employee.professional.form.registry': 'Registry',
  'employee.professional.form.company': 'Company',
  'employee.professional.form.situation': 'Situation',
  'employee.professional.form.type': 'Type',
  'employee.professional.form.areas': 'Areas',
  'employee.professional.form.academyLevel': 'Academy Level',
  'employee.professional.form.role': 'Role',
  'employee.professional.form.occupation': 'Occupation',
  'employee.professional.form.email': 'E-mail',
  'employee.professional.form.admissionDate': 'Admission Date',
  'employee.professional.form.workCard': 'Work Card',
  'employee.professional.form.pis': 'PIS Number',
  'employee.professional.form.salary': 'Salary',
  'employee.professional.form.pieceCommission': 'Piece Commission (%)',
  'employee.professional.form.serviceCommission': 'Service Commission (%)',
  'employee.professional.form.busLines': 'Bus Lines',
  'employee.professional.form.ticketValue': 'Ticket Value',
  'employee.professional.form.vehicleCode': 'Vehicle code',
  'employee.professional.form.observation': 'Observations',
  'employee.professional.form.estimator': 'Are you an estimator/seller?',

  'employee.professional.success.message': 'Success!',
  'employee.professional.success.description':
    'Professional data saved successfully',

  'employee.filters.active.options.all': 'All',
  'employee.filters.active.options.active': 'Active',
  'employee.filters.active.options.inactive': 'Inactive',
  'employee.modal.report.title': 'Generate Report',
  'employee.modal.report.buttons.viewReport': 'View Report',
  'employee.modal.report.buttons.pdf': 'PDF',
  'employee.modal.report.buttons.csv': 'CSV',
  'employee.notification.generate.report.title':
    'Report generated successfully!',
  'employee.notification.generate.report.description':
    'Employee Report Successfully Generated!',
  'employee.professional.form.contacts': 'Contacts',

  'employee.modal.report.form.upUntil': 'Up until',
  'employee.modal.report.form.specificDate': 'Specific Date Birthday',

  'employee.cpfIncorrect.error': 'CPF entered is incorrect!',
  'employee.cpfAlreadyExists':
    'There is already an employee registered with this CPF',

  'employee.modal.selectedEmployees.title.add': 'Add Employee',
  'employee.modal.selectedEmployees.search': 'Search for Employees',
};
